/* =========================================================
   PAS · Free gift  (snippets/pas-free-gift.liquid)

   These are custom elements, not an inline <script> inside the snippet on
   purpose: every cart change swaps #minicart-form for a freshly rendered
   copy, and a browser never runs <script> tags that arrive inside innerHTML.
   A custom element upgrades whenever its markup lands in the DOM, so Add
   keeps working after every cart change.

   What it does
   ------------
   Add      POST /cart/add.js with the gift variant, remember it in
            sessionStorage so the block can say "still waiting" later.
   auto-add Off by default for Pet Art Space. Only when data-auto-add="1"
            would Add run without a click; shoppers must tap Add. Removed
            gifts stay manual either way.
   verify   Re-read /cart.js so the card never gets stuck on "in the cart"
            after the shopper deletes the line by hand.
   orphan   When nothing in the cart qualifies for the gift any more the
            snippet prints <pas-free-gift-state>: the gift line is taken back
            out, because the automatic discount will not apply and the
            shopper would pay full price for a "free" gift.

   There is no decline handler: not pressing Add is the refusal, so nothing
   is written to the cart attributes and nobody can end up stuck in a
   "declined" state they cannot undo.
   ========================================================= */
(function () {
  'use strict';

  var ADDED = 'pas_fg_added';
  var SEEN = 'pas_fg_seen';
  var REMOVE_GUARD = 'pas_fg_removed_at';

  function ssGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function ssSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function cartJson() {
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      return r
        .json()
        .catch(function () {
          return null;
        })
        .then(function (data) {
          if (!r.ok) {
            var msg =
              data && (data.description || data.message)
                ? data.description || data.message
                : 'Shopify answered HTTP ' + r.status + '.';
            throw new Error(msg);
          }
          return data;
        });
    });
  }

  /* Keep the header counter and the free shipping bar in step with the cart. */
  function syncCart(cart) {
    if (!cart || cart.item_count === undefined) return;
    try {
      if (typeof pasSetCartCountBadges === 'function') {
        pasSetCartCountBadges(cart);
      } else {
        var count = 0;
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i] || {};
          var typ = String(it.product_type || '').toUpperCase();
          var handle = String(it.handle || '');
          if (typ === 'PPLR_HIDDEN_PRODUCT' || handle === 'item-personalization') continue;
          count += parseInt(it.quantity, 10) || 0;
        }
        var counters = document.querySelectorAll('.cart-count');
        for (var j = 0; j < counters.length; j++) {
          var el = counters[j];
          el.innerHTML = el.classList.contains('cart-count-drawer')
            ? '(' + count + ')'
            : count > 100
              ? '~'
              : String(count);
        }
      }
      var shipBar = document.querySelector('free-ship-progress-bar');
      if (shipBar && typeof shipBar.init === 'function') {
        shipBar.init(cart.items_subtotal_price);
      }
    } catch (e) {}
  }

  /* Drawer: swap in a freshly rendered #minicart-form. Cart page: reload,
     because the totals, the discount line and the item table all move. */
  function refresh(place, base) {
    if (place !== 'drawer') {
      window.location.reload();
      return Promise.resolve();
    }
    var form = document.getElementById('minicart-form');
    if (!form) {
      window.location.reload();
      return Promise.resolve();
    }
    /* Same endpoint the theme's own cart code uses: ask Shopify to render
       just the minicart-form section and swap it in. */
    var url = (base || '/cart') + '?section_id=minicart-form';
    return fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
        if (!next) {
          window.location.reload();
          return;
        }
        form.innerHTML = next.innerHTML;
        return cartJson().then(syncCart);
      })
      .catch(function () {
        window.location.reload();
      });
  }

  class PasFreeGift extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pasReady === '1') return;
      this.dataset.pasReady = '1';

      this.place = this.getAttribute('data-place') || 'drawer';
      this.variant = parseInt(this.getAttribute('data-variant'), 10) || 0;
      this.err = this.querySelector('[data-pas-fg-err]');

      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);

      /* The server printed the state as the cart was when this markup was
         made. Take it as a starting point, then keep it honest against
         /cart.js — the line can be deleted without this element ever being
         re-rendered, and then there is nothing left to say "you can put it
         back" unless the block is already on the page. */
      if (this.classList.contains('is-added')) ssSet(ADDED, '1');
      this.verify();
      this.watch();

      if (ssGet(ADDED) === '1' && !this.classList.contains('is-added')) {
        this.classList.add('is-reinvite');
      }

      this.celebrate();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.verifyTimer) {
        clearTimeout(this.verifyTimer);
        this.verifyTimer = null;
      }
    }

    /* Anything that changes the cart markup can change the answer, and the
       theme does not always rebuild this block when it does (a quantity
       change on the cart page only re-renders the item table). Watch the
       container the items live in, not this element. */
    watch() {
      var root =
        this.getAttribute('data-place') === 'drawer'
          ? document.getElementById('minicart-form')
          : document.querySelector('.main-cart');
      if (!root) root = this.parentElement;
      if (!root || typeof MutationObserver !== 'function') return;

      var el = this;
      this.observer = new MutationObserver(function () {
        if (el.verifyTimer) clearTimeout(el.verifyTimer);
        el.verifyTimer = setTimeout(function () {
          el.verifyTimer = null;
          el.verify();
        }, 300);
      });
      this.observer.observe(root, { childList: true, subtree: true });
    }

    handleClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var add = target.closest('[data-pas-fg-add]');
      if (add && this.contains(add)) {
        event.preventDefault();
        this.add();
      }
    }

    celebrate() {
      if (!this.hasAttribute('data-celebrate')) return;
      if (this.hidden) return;
      if (ssGet(SEEN) === '1') return;
      ssSet(SEEN, '1');
      var el = this;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-celebrate');
        });
      });
    }

    setState(inCart) {
      if (inCart) {
        /* Silently step aside — the gift line in the item list is the
           confirmation. No bar, no badge. */
        ssSet(ADDED, '1');
        this.classList.add('is-added');
        this.classList.remove('is-reinvite');
        this.hidden = true;
        return;
      }
      this.hidden = false;
      this.classList.remove('is-added');
      /* Added once in this browsing session, not there now → the softer
         "still waiting" bar instead of the full card again. */
      if (ssGet(ADDED) === '1') this.classList.add('is-reinvite');
      else this.classList.remove('is-reinvite');
    }

    verify() {
      if (!this.variant) return;
      var el = this;
      cartJson()
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var inCart = false;
          for (var i = 0; i < items.length; i++) {
            if (parseInt(items[i].variant_id, 10) === el.variant) {
              inCart = true;
              break;
            }
          }
          el.setState(inCart);
          /* Optional: only when data-auto-add="1". Default off — show offer,
             wait for Add. Skip reinvite / sold-out fail. */
          if (!inCart) el.maybeAutoAdd();
        })
        .catch(function () {});
    }

    maybeAutoAdd() {
      if (this.getAttribute('data-auto-add') !== '1') return;
      if (this._autoStarted) return;
      if (this.dataset.busy === '1') return;
      if (this.classList.contains('is-added')) return;
      if (this.classList.contains('is-reinvite')) return;
      if (this.hidden) return;
      if (ssGet(ADDED) === '1') return;
      if (ssGet('pas_fg_auto_fail') === '1') return;
      this._autoStarted = true;
      this.add();
    }

    showError(message) {
      if (!this.err) return;
      this.err.textContent = message;
      this.err.hidden = false;
      try {
        console.error('[pas-free-gift]', message);
      } catch (e) {}
    }

    clearError() {
      if (!this.err) return;
      this.err.hidden = true;
      this.err.textContent = '';
    }

    add() {
      if (this.dataset.busy === '1' || !this.variant) return;
      var el = this;
      el.dataset.busy = '1';
      el.clearError();

      postJson('/cart/add.js', { items: [{ id: el.variant, quantity: 1 }] })
        .then(function () {
          /* Remembered before the re-render, so the next render can tell
             "never added" from "added and taken back out". */
          ssSet(ADDED, '1');
          el.classList.add('is-added');
          el.hidden = true;
          return refresh(el.place, el.getAttribute('data-cart-url'));
        })
        .catch(function (err) {
          el.dataset.busy = '0';
          el._autoStarted = false;
          var msg = err && err.message ? err.message : 'The gift could not be added.';
          var soldOut = /sold out|inventory|not enough|unavailable|cannot be added/i.test(msg);
          if (soldOut) {
            /* First-50 / inventory exhausted — hide the offer entirely. */
            ssSet('pas_fg_auto_fail', '1');
            el.hidden = true;
            el.classList.add('is-hidden');
            return;
          }
          el.showError(msg);
        });
    }
  }

  /* Printed only when the gift sits in the cart but nothing qualifies for it
     any more. Takes the line back out so the shopper is not charged for it. */
  class PasFreeGiftState extends HTMLElement {
    connectedCallback() {
      if (this.getAttribute('data-remove') !== '1') return;
      var key = this.getAttribute('data-line-key');
      if (!key) return;

      var now = Date.now();
      var last = parseInt(ssGet(REMOVE_GUARD), 10) || 0;
      if (now - last < 8000) return;
      ssSet(REMOVE_GUARD, String(now));

      var base = this.getAttribute('data-cart-url') || '/cart';
      var place = this.getAttribute('data-place') || 'drawer';
      postJson('/cart/change.js', { id: key, quantity: 0 })
        .then(function () {
          refresh(place, base);
        })
        .catch(function () {});
    }
  }

  if (!customElements.get('pas-free-gift')) customElements.define('pas-free-gift', PasFreeGift);
  if (!customElements.get('pas-free-gift-state')) {
    customElements.define('pas-free-gift-state', PasFreeGiftState);
  }
})();
